export default "__VITE_ASSET__Bjyg8Paf__"